import { useState, useEffect } from "react";
import { Button, Input, Modal, Form, Select, InputNumber } from "antd";
import { formatToUTCDateString } from "../../utils";
import { chargerTypeOptions } from "../../constants/helperConstants";
const { Option } = Select;

const AddPricingInBrandModelModal = (props: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { isModalOpen, brandModel, onCancel, addPricing, selectedPricing, onUpdatePricing, isEditMode } =
    props;

  form.setFieldValue("brand_model_id", brandModel?.id);
  form.setFieldValue("brand_model_name", brandModel?.name);
  form.setFieldsValue({
    ...selectedPricing,
    start_date: formatToUTCDateString(selectedPricing?.start_date),
    end_date: formatToUTCDateString(selectedPricing?.end_date)
  });

  const onFinish = (values: any) => {
    if (Object.keys(selectedPricing).length === 0) {
      const params = { brandModelId: brandModel?.id, pricingData: { pricing: values } };
      addPricing(params, setLoading, form);
    } else {
      const params = { brandModelId: brandModel?.id, pricingData: { pricing: values }, id: selectedPricing?.id };
      onUpdatePricing(params, setLoading, form);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      title={isEditMode ? "Update Pricing" : "Add Pricing"}
      open={isModalOpen}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      footer={false}
    >
      <Form
        name="pricing_form"
        form={form}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item name="brand_model_name" label="Model Name">
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="pricing_per_meter"
          label="Pricing per meter"
          rules={[
            { required: true, message: "Please enter price" },
            { type: "number", min: 50, message: "Price should be greater than or equal to 50" },
            { type: "number", max: 10000, message: "Price should be less than or equal to 10000" }
          ]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="complementary_cable_length"
          label="Complementary cable length"
          rules={[
            { required: true, message: "Please enter length" },
            {
              type: "number",
              min: 0,
              message: "Cable length should be greater than or equal to 0"
            },
            {
              type: "number",
              max: 1000,
              message: "Cable length should be less than or equal to 1000"
            }
          ]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="start_date"
          label="Start date"
          rules={[{ required: true, message: "Please select start date" }]}
        >
          <Input type="date" min={new Date().toISOString().slice(0, 10)} />
        </Form.Item>

        <Form.Item
          name="end_date"
          label="End date"
          rules={[{ required: true, message: "Please select end date" }]}
        >
          <Input type="date" min={new Date().toISOString().slice(0, 10)} />
        </Form.Item>

        <Form.Item name="charger_size" label="Charger Type">
          <Select
            placeholder="Select charger type"
            showSearch
            optionFilterProp="children"
            options={chargerTypeOptions}
            filterOption={(inputValue, option: any) =>
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            }
          ></Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isEditMode ? "Update" : "Add"}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddPricingInBrandModelModal;
